import React from 'react';

import { connect } from 'react-redux';
import { zipObject, cloneDeep } from '../../utils/lodash';

import tobeor from 'tobeor';
import { withStyles } from '@mui/styles';

import ChatContainerStyles from './ChatContainerStyles.js';

import { Select } from '@mui/material';

import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

import Contacts from './components/Contacts.js';
import Chat from './components/Chat.js';

import Media from 'react-media';
import { Link } from 'react-router-dom';

import Loader from '../Loader';
import TrplForm from '../TrplForm/TrplForm';
import CommonStyles from '../CommonStyles.js';
import ComponentWrapper from '../ComponentWrapper';
import TrplFormFullScreenDialog from '../TrplForm/TrplFormFullScreenDialog.js';

import { getRandomInteger, getUrlParameter, objectToQuerystring, setUrlParameter, validateEmail, contactParams } from '../../utils';
import ActionConfirmation from '../ActionConfirmation';
import { ALL_CATEGORIES, CHECKBOX_ALL } from './components/Contacts';
import { SELECT_PLACEHOLDER } from '../../constants';
import produce from 'immer';

import { setSetupAccounts, updateSetupData, setSetupContactsTboxData } from '../../reducer/metaReducer.js';

const notificationSound = new Audio('/datapunk/sounds/notification-sound.mp3');

const styles = {
  ...CommonStyles,
  ...ChatContainerStyles,
};

const HIDDEN_CHAT_CATEGORIES = 'hidden_chat_categories';

class ChatContainer extends ComponentWrapper {
  constructor(props) {
    super();

    this.state = {
      subs: [],
      init: true,
      amount: '',
      subsData: {},
      paymentPrice: '',
      paymentsTitles: {},
      contactsList: [],
      msgTemplates: [],
      chatTabs: [],
      pageTitle: '',
      chatTemplateId: '',
      amountEdit: false,
      subValue: [],
      chatTabsInit: false,
      chatTemplate: 'none',
      chatMsgLoaded: true,
      chatTemplatePids: [],
      pageTitleOnStart: '',
      selectedIndex: null,
      isSendingMsg: false,
      invoicesAddNew: false,
      selectedContact: null,
      pageTitleIntervalId: '',
      isScrollInBottom: false,
      isMetaDataOpened: false,
      getContactsHolded: false,
      chatSettingsAnchor: null,
      unseenAmountCounterLast: 0,
      isSendPopoverVisible: false,
      isTabTextChangeWorking: false,
      selectedContactMobileValue: '',
      loadingConfirmDeleteMsg: false,
      chatRecepientEditModalOpened: null,
      emailInfo: { from: '', replyTo: '', subject: '', to: '' },
      isChatInfoValid: { from: false, to: false, replyTo: false },
      isMobile: false,
      unseenMsgCounters: {},
      contactsIsLoaded: false,
      contactIsLoaded: true,
      isLastTab: true,
      hotkeysPressed: {
        enter: false,
        shift: false,
        ctrl: false,
      },
      smsInfo: { from: '', to: '' },
      fbInfo: { from: '', to: '' },
      tgInfo: {
        from: '',
        to: '',
      },
      imgUploadForm: {
        isOpened: false,
        images: [],
      },
      deleteMsgModal: {
        msgId: 0,
        isOpened: false,
      },
      draftMessages: {},
      channelConceptTo: null,
      webInfo: { from: '', to: '' },
    };
  }

  componentDidMount() {
    document.title = "Chat | Milkyweb";

    const isMobile = window.innerWidth <= 900;
    const pageTitleOnStart = document.querySelector('title').innerHTML;

    const randomTabCounter = getRandomInteger(0, 10000);
    localStorage.setItem('tabCounter', randomTabCounter);

    const chatChannelsConceptId = this.extractChatConceptIdFromUrl();

    this.getFlows();

    setInterval(() => {
      if (randomTabCounter !== +localStorage.getItem('tabCounter')) {
        this.setState({ isLastTab: false });

        for (let i = 0; i <= 3; i++) {
          window.clearInterval(i);
        }
      }
    }, 60000);

    this.setState(
      {
        isMobile,
        pageTitle: pageTitleOnStart,
        pageTitleOnStart,
      },
      () => {
        if (this.props.addon && chatChannelsConceptId) {
          this.getCommunicationChannels(chatChannelsConceptId);
        } else this.getContacts();
      }
    );

    if (!isMobile) {
      window.onfocus = () => {
        if (this.state.isTabTextChangeWorking) this.stopChangeTabText();
      };

      window.onclick = () => {
        if (this.state.isTabTextChangeWorking) this.stopChangeTabText();
      };
    }

    setInterval(() => {
      const { isSendingMsg } = this.state;

      if (isSendingMsg) {
        this.setState({
          getContactsHolded: true,
        });
      } else if (this.props.addon) {
        this.getContactsByAncestor(true);
      } else this.getContacts(true);
    }, 60000);
  };

  getFlows = () => {
    this.get({
      url: '/get_jel?type=["flow"]',
      cb: (res) => {
        const msgTemplates = res.flow || [];

        this.setState({ msgTemplates });
      }
    })
  };

  extractChatConceptIdFromUrl = () => {
    const url = window.location.href;

    const regex = /\/chat\/(\d+)/;
    const match = url.match(regex);
    
    if (match && match[1]) {
      return match[1];
    } else {
      return null;
    }
  };

  getCommunicationChannels = (chatAncestor) => {
    const { setup } = this.props;

    const show_pids = [
      1292,
      1293,
      1297,
      1300,
      1307,
      "1293.1294", // twilio.Phone number
      "1297.1298", // telegram.Bot name
      "1300.1302", // email.From email
      "1300.1304", // email.Reply to email
      "1307.1308", // facebook.Messenger id
    ];

    const data = {
      api_key: setup.id,
      show_pids,
      nesting: 2,
      filter: {
        ancestor: 4668492,
        trpls: [
          { pids_chain: [1292], op: "=", con: "AND", val: chatAncestor}, // concept
          //{ pids_chain: [1293], op: "is not null", con: "AND" }, // twilio
          // { pids_chain: [1297], op: "is not null", con: "AND" }, // telegram
          // { pids_chain: [1300], op: "is not null", con: "OR" }, // email
          // { pids_chain: [1307], op: "is not null", con: "OR" }, // facebook
        ],
        limit: 1,
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data,
      cb: (data) => {
        if (data && data._status === "ok" && data.trpls) {
          const channelNode = data.query[0];

          const twilioNumberChannel = (data.trpls[channelNode] && data.trpls[channelNode][1293] && data.trpls[channelNode][1293][0].oid) ?
            data.trpls[data.trpls[channelNode][1293][0].oid] && data.trpls[data.trpls[channelNode][1293][0].oid][1294] &&
            data.trpls[data.trpls[channelNode][1293][0].oid][1294][0].val : null;

          const telegramBotNameChannel = (data.trpls[channelNode] && data.trpls[channelNode][1297] && data.trpls[channelNode][1297][0].oid) ?
            data.trpls[data.trpls[channelNode][1297][0].oid] && data.trpls[data.trpls[channelNode][1297][0].oid][1298] &&
            data.trpls[data.trpls[channelNode][1297][0].oid][1298][0].val : null;

          const emailFromChannel = (data.trpls[channelNode] && data.trpls[channelNode][1300] && data.trpls[channelNode][1300][0].oid) ?
            data.trpls[data.trpls[channelNode][1300][0].oid] && data.trpls[data.trpls[channelNode][1300][0].oid][1302] &&
            data.trpls[data.trpls[channelNode][1300][0].oid][1302][0].val : null;

          const emailToChannel = (data.trpls[channelNode] && data.trpls[channelNode][1300] && data.trpls[channelNode][1300][0].oid) ?
            data.trpls[data.trpls[channelNode][1300][0].oid] && data.trpls[data.trpls[channelNode][1300][0].oid][1304] &&
            data.trpls[data.trpls[channelNode][1300][0].oid][1304][0].val : null;

          const facebookMidChannel = (data.trpls[channelNode] && data.trpls[channelNode][1307] && data.trpls[channelNode][1307][0].oid) ?
            data.trpls[data.trpls[channelNode][1307][0].oid] && data.trpls[data.trpls[channelNode][1307][0].oid][1308] &&
            data.trpls[data.trpls[channelNode][1307][0].oid][1308][0].val : null;

          if (channelNode) this.getContactsByAncestor(null, chatAncestor, { emailChannel: {from: emailFromChannel, reply_to: emailToChannel}, twilioNumberChannel, facebookMidChannel, telegramBotNameChannel } );
          else {
            this.setState({ contactsIsLoaded: true });
            console.log('no channel node found');
          }
        }
      }
    });
  };

  getContactsByAncestor = (disableDialogSelect, chatAncestor, channelParams = {}) => {
    const cont = this;
    const { init, isMobile, unseenAmountCounterLast, isTabTextChangeWorking, channelConceptTo } = this.state;

    let queryStr;
    let chatTabs = [];
    const currentChatConceptTo = chatAncestor ? chatAncestor : channelConceptTo;

    if (!currentChatConceptTo) return null;

    if (!this.props.setup_contacts_tbox || (this.props.setup_contacts_tbox && !this.props.setup_contacts_tbox.nodes)) {
      queryStr = `/chatlist/${currentChatConceptTo}?meta_query=["setup_contacts_tbox", "setup_accounts"]`;
    } else {
      queryStr = `/chatlist/${currentChatConceptTo}`;
    }
    
    this.get({
      url: queryStr,
      cb: (res) => {
        if (!res || res && res._status === 'error') return null;

        let contactsList = res.talks.map(talk => zipObject(contactParams, talk));

        const contactSelectedId = getUrlParameter('contact_id');

        if (res._meta_query) {
          if (res._meta_query.setup_accounts) this.props.setSetupAccounts(res._meta_query);
          if (res._meta_query.setup_contacts_tbox) this.props.setSetupContactsTboxData(res._meta_query);
        }
        const { emailInfo, smsInfo, fbInfo, tgInfo, webInfo } = cont.state;
        const { emailChannel = null, twilioNumberChannel = null, facebookMidChannel = null, telegramBotNameChannel = null } = channelParams;

        if (emailChannel && (emailChannel.from || emailChannel.reply_to)) {
          emailInfo.from = emailChannel.from;
          emailInfo.replyTo = emailChannel.reply_to;
        }

        if (twilioNumberChannel) smsInfo.from = twilioNumberChannel;

        if (facebookMidChannel) fbInfo.from = facebookMidChannel;

        if (telegramBotNameChannel) tgInfo.from = telegramBotNameChannel;

        if (webInfo) webInfo.from = contactsList[0].contact_info.CONTACT_ID || '';

        cont.setState({
          channelConceptTo: currentChatConceptTo,
          emailInfo: { ...emailInfo },
          smsInfo: { ...smsInfo },
          fbInfo: { ...fbInfo },
          tgInfo: { ...tgInfo },
          webInfo: { ...webInfo },
        });

        const isEmails = typeof emailChannel === 'object' && emailInfo.from;
        const isSms = twilioNumberChannel;
        const isFb = facebookMidChannel;
        const isTg = telegramBotNameChannel;

        if (init) {
          const subs = (res._meta_query && res._meta_query.setup_contacts_tbox) ||
            this.props.setup_contacts_tbox;

          if (isSms) chatTabs.push({ value: 'sms', isSelected: true });
          if (isEmails) chatTabs.push({ value: 'email', isSelected: false });
          if (isTg) chatTabs.push({ value: 'telegram', isSelected: false });
          if (isFb) chatTabs.push({ value: 'facebook', isSelected: false });

          if (chatTabs.length && chatTabs[0] && chatTabs[0].isSelected === false) chatTabs[0].isSelected = true;
          if (!chatTabs.length) chatTabs = [
            {
              value: 'email',
              isSelected: true,
            },
          ];

          const tabInUrl = getUrlParameter('tab');

          if (tabInUrl) {
            chatTabs.forEach((tab) => {
              if (tab.value === tabInUrl) {
                tab.isSelected = true;
              } else {
                tab.isSelected = false;
              }
            });
          }

          let subsData = {
            restrictions: {},
          };

          if (subs.nodes)
          Object.keys(subs.nodes).forEach(concept => {
            const sub = subs.nodes[concept];
              let counter = 0;

              contactsList.forEach(contact => {
                if (contact.ancestors && contact.ancestors.includes(sub.id)) {
                  counter++;
                }
              });

              subsData[sub.id] = {
                count: counter,
              };

              if (sub && sub.box.r) {
                Object.keys(sub.box.r).forEach(concept => {
                  const rstConcept = sub.box.r[concept];
                  rstConcept.forEach(rst => subsData.restrictions[rst.id] = rst.title);
                });
              }
          });

          this.initContactSelectCheckboxes(subs);

          cont.setState({
            chatTabs: [...chatTabs],
            subsData,
          });
        }

        let unseenAmountCounter = 0;

        let hiddenCategories = this.getHiddenChatCategories();
        contactsList.forEach((contact) => {
          let isContactMuted = this.isContactMuted(contact.contact_info.contact_id, contact, hiddenCategories);

          if (contact.unseen.total && !isContactMuted) unseenAmountCounter += contact.unseen.total;

          contact.contactTitle = contact.contact_info.title;
        });

        if (unseenAmountCounter > 0) {

          if (unseenAmountCounter > unseenAmountCounterLast) {
            if (!init) notificationSound.play();

            if (!isTabTextChangeWorking && !init && !isMobile) cont.startChangeTabText(unseenAmountCounter);
          }

          cont.setState({
            unseenAmountCounterLast: unseenAmountCounter,
          });
        } else {
          if (isTabTextChangeWorking && !isMobile) cont.stopChangeTabText();
        }

        let contact;
        let selectedIndex;

        if (contactSelectedId) {
          contact = contactsList.find((contact, index) => {
            return +contact.contact_info.contact_id === +contactSelectedId;
          });

          selectedIndex = contactsList.findIndex((contact) => {
            return +contact.contact_info.contact_id === +contactSelectedId;
          });

          if (contact) {
            const selectedContactMobileValue = cont.getRecipient(contact.contact_info);

            if (isMobile) {
              cont.setState({ selectedContactMobileValue });
            }
          }
        }

        if (contactSelectedId && !disableDialogSelect) {
          // if contact is not in contacts list
          if (!contact) {
            cont.setState(
              {
                contactsList: [...contactsList],
                contactsIsLoaded: true,
              }
            );
            
            return;
          }

          cont.setState(
            {
              contactsList: [...contactsList],
              selectedIndex,
              contactsIsLoaded: true,
            },
            () => {
              cont.onContactSelect(contact.contact_info.contact_id, selectedIndex);
            }
          );

          return;
        }

        cont.setState(
          {
            contactsList: [...contactsList],
            selectedIndex,
            contactsIsLoaded: true,
            getContactsHolded: false,
          },
          () => {
            const { selectedContact } = cont.state;

            if (
              (selectedContact) &&
              contactsList[selectedIndex] &&
              contactsList[selectedIndex].unseen &&
              contactsList[selectedIndex].unseen.total > 0
            ) {
              cont.updateSelectedContact(unseenAmountCounter);
            }
          }
        );
      },
    });
  };

  getContacts = (disableDialogSelect) => {
    const cont = this;
    const { init, isMobile, unseenAmountCounterLast, isTabTextChangeWorking } = this.state;

    let queryStr;

    if (!Object.values(this.props.setup_contacts_tbox).length) {
      queryStr = `/chatlist?meta_query=["setup_contacts_tbox", "setup_accounts"]`;
    } else {
      queryStr = `/chatlist`;
    }
    
    let chatTabs;

    this.get({
      url: queryStr,
      cb: (res) => {
        let contactsList = res.talks.map(talk => zipObject(contactParams, talk));

        // Get current contact ID from URL if any
        const contactSelectedId = getUrlParameter('contact_id');

        if (res._meta_query) {
          if (res._meta_query.setup_accounts) this.props.setSetupAccounts(res._meta_query);
          if (res._meta_query.setup_contacts_tbox) this.props.setSetupContactsTboxData(res._meta_query);
        }

        const { emailInfo, smsInfo, fbInfo, tgInfo, webInfo } = cont.state;

        const { setup } = this.props;
        const setupEmails = setup.emails;
        const setupSms = setup.twilio;
        const facebookMid = setup.facebook_mid || '';
        const tgBotName = setup.telegram ? setup.telegram.botname : '';

        const isEmails = typeof setupEmails === 'object' && Object.keys(setupEmails).length > 0;
        const isSms = typeof setupSms === 'object' && Object.keys(setupSms).length > 0;
        const isFb = facebookMid.length;
        const isTg = tgBotName;

        if (isEmails) {
          emailInfo.from = setup.emails.from || '';
          emailInfo.replyTo = setup.emails.reply_to || '';
        }

        if (isSms) smsInfo.from = setup.twilio.number || '';

        if (isFb) fbInfo.from = facebookMid;

        if (isTg) tgInfo.from = tgBotName;

        if (webInfo) webInfo.from = contactsList[0].contact_info.CONTACT_ID || '';

        cont.setState({
          emailInfo: { ...emailInfo },
          smsInfo: { ...smsInfo },
          fbInfo: { ...fbInfo },
          tgInfo: { ...tgInfo },
          webInfo: { ...webInfo },
        });

        if (init) {
          const subs = (res._meta_query && res._meta_query.setup_contacts_tbox) ||
            this.props.setup_contacts_tbox;

          if (isEmails && isSms && isFb && !isTg) {
            chatTabs = [
              { value: 'sms', isSelected: true },
              { value: 'email', isSelected: false },
              { value: 'facebook', isSelected: false },
            ];
          } else if (isEmails && isSms && isFb && isTg) {
            chatTabs = [
              { value: 'sms', isSelected: true },
              { value: 'email', isSelected: false },
              { value: 'facebook', isSelected: false },
              { value: 'telegram', isSelected: false },
            ];
          } else if (isEmails && !isSms && !isFb) {
            chatTabs = [{ value: 'email', isSelected: true }];
          } else if (!isEmails && isSms && !isFb) {
            chatTabs = [{ value: 'sms', isSelected: true }];
          } else if (isSms && isFb) {
            chatTabs = [
              { value: 'sms', isSelected: true },
              { value: 'facebook', isSelected: false },
            ];
          } else {
            chatTabs = [
              {
                value: 'email',
                isSelected: true,
              },
            ];
          }

          const tabInUrl = getUrlParameter('tab');

          if (tabInUrl) {
            chatTabs.forEach((tab) => {
              if (tab.value === tabInUrl) {
                tab.isSelected = true;
              } else {
                tab.isSelected = false;
              }
            });
          }

          let subsData = {
            restrictions: {},
          };

          if (subs.nodes)
          Object.keys(subs.nodes).forEach(concept => {
            const sub = subs.nodes[concept];
              let counter = 0;

              contactsList.forEach(contact => {
                if (contact.ancestors && contact.ancestors.includes(sub.id)) {
                  counter++;
                }
              });

              subsData[sub.id] = {
                count: counter,
              };

              if (sub && sub.box.r) {
                Object.keys(sub.box.r).forEach(concept => {
                  const rstConcept = sub.box.r[concept];
                  rstConcept.forEach(rst => subsData.restrictions[rst.id] = rst.title);
                });
              }
          });

          this.initContactSelectCheckboxes(subs);

          cont.setState({
            chatTabs: [...chatTabs],
            subsData,
          });
        }

        let unseenAmountCounter = 0;

        let hiddenCategories = this.getHiddenChatCategories();
        contactsList.forEach((contact) => {
          let isContactMuted = this.isContactMuted(contact.contact_info.contact_id, contact, hiddenCategories);

          if (contact.unseen.total && !isContactMuted) unseenAmountCounter += contact.unseen.total;

          contact.contactTitle = contact.contact_info.title;
        });

        if (unseenAmountCounter > 0) {
          //const { subValue } = cont.state;

          if (unseenAmountCounter > unseenAmountCounterLast) {
            if (!init) notificationSound.play();

            if (!isTabTextChangeWorking && !init && !isMobile) cont.startChangeTabText(unseenAmountCounter);
          }

          //if (subValue !== 'contact') cont.setState({ subValue: 'contact' }); // might not useful code, remove later

          cont.setState({
            unseenAmountCounterLast: unseenAmountCounter,
          });
        } else {
          if (isTabTextChangeWorking && !isMobile) cont.stopChangeTabText();
        }

        let contact;
        let selectedIndex;

        if (contactSelectedId) {
          contact = contactsList.find((contact, index) => {
            return +contact.contact_info.contact_id === +contactSelectedId;
          });

          selectedIndex = contactsList.findIndex((contact) => {
            return +contact.contact_info.contact_id === +contactSelectedId;
          });

          if (contact) {
            const selectedContactMobileValue = cont.getRecipient(contact.contact_info);

            if (isMobile) {
              cont.setState({ selectedContactMobileValue });
            }
          }
        }

        if (contactSelectedId && !disableDialogSelect) {
          // if contact is not in contacts list
          if (!contact) {
            cont.setState(
              {
                contactsList: [...contactsList],
                contactsIsLoaded: true,
              }
            );

            return;
          }

          cont.setState(
            {
              contactsList: [...contactsList],
              selectedIndex,
              contactsIsLoaded: true,
            },
            () => {
              cont.onContactSelect(contact.contact_info.contact_id, selectedIndex);
            }
          );

          return;
        }

        cont.setState(
          {
            contactsList: [...contactsList],
            selectedIndex,
            contactsIsLoaded: true,
            getContactsHolded: false,
          },
          () => {
            const { selectedContact } = cont.state;

            if (
              (selectedContact) &&
              contactsList[selectedIndex] &&
              contactsList[selectedIndex].unseen &&
              contactsList[selectedIndex].unseen.total > 0
            ) {
              cont.updateSelectedContact(unseenAmountCounter);
            }
          }
        );
      },
    });
  };

  updateSeenTime = () => {
    const {
      selectedContact,
      contactsList,
      selectedIndex,
      emailInfo,
      smsInfo,
      fbInfo,
      tgInfo,
      webInfo,
    } = this.state;

    let { unseenMsgCounters } = this.state;

    const action = 'chat';
    const selectedTab = this.getChatSelectedTab();

    const id = `contact_id=${selectedContact.id}`;

    unseenMsgCounters[selectedTab.toUpperCase()] = 0;

    const contactParam =
      selectedTab === 'email'
        ? emailInfo.to
        : selectedTab === 'sms'
        ? smsInfo.to
        : selectedTab === 'facebook'
        ? fbInfo.to
        : selectedTab === 'telegram'
        ? tgInfo.to
        : selectedTab === 'web'
        ? webInfo.to
        : '';

    const queryStr = `action=${action}&${id}&tab=${selectedTab}&contact=${contactParam}`;

    if (contactsList[selectedIndex]) contactsList[selectedIndex].unseen.total = 0;

    this.postWithData({
      url: '/upd_seen_time',
      data: queryStr,
      cb: () => {
        if (contactsList[selectedIndex])
          this.setState({
            contactsList: cloneDeep(contactsList),
            selectedContact:  cloneDeep(selectedContact),
            unseenMsgCounters: { ...unseenMsgCounters },
          });
      },
    });
  };

  onContactSelect = (contactId, selectedIndex, changeTabs, disableLoader, lastMsgId) => {
    const cont = this;
    const state = this.state;
    const { contactsList, emailInfo, smsInfo, fbInfo, tgInfo, isMobile } = state;

    if (!disableLoader) {
      this.setState({ contactIsLoaded: false });
    }

    this.setState({ chatTemplatePids: [] });

    let { unseenAmountCounterLast } = state;

    this.removeUnreadLineElem();
    this.removeUploadedImages();

    const contact = contactsList.find(contact => contact.contact_info.contact_id === contactId);
    
    // Determine all available channels for the contact
    const availableChannels = [];
    if (contact.contact_info.EMAIL) availableChannels.push('email');
    if (contact.contact_info.PHONE) availableChannels.push('sms');
    if (contact.contact_info.FACEBOOK_MID) availableChannels.push('facebook');
    if (contact.contact_info.TELEGRAM_ID) availableChannels.push('telegram');
    if (contact.contact_info.CONTACT_ID) availableChannels.push('web');

    // If no channels available, default to email
    if (availableChannels.length === 0) {
      availableChannels.push('email');
    }

    // Determine which tab should be selected
    let selectedTab;
    // Use the type from the last message in chatlist
    if (contact.type && availableChannels.includes(contact.type.toLowerCase())) {
      selectedTab = contact.type.toLowerCase();
    } else {
      selectedTab = availableChannels[0];
    }

    // Update URL with current contact and tab
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('contact_id', contactId);
    currentUrl.searchParams.set('tab', selectedTab);
    window.history.replaceState({}, '', currentUrl.toString());

    // Create new tabs array with correct selection
    const newChatTabs = availableChannels.map(channel => ({
      value: channel,
      isSelected: channel === selectedTab
    }));

    // Update state with new tabs before making the request
    this.setState({ 
      chatTabs: newChatTabs,
      chatTemplate: 'none',
      chatTemplateId: '',
      chatTemplatePids: []
    });

    // Get messages for the selected tab
    let url = `/get_contacts_talks?contact_id=${contactId}&tab=${selectedTab}`;
    if (lastMsgId) url = `${url}&last_msg_id=${lastMsgId}`;

    this.get({
      url,
      cb: (selectedContact) => {
        selectedContact.isSeen = false;
        selectedContact.id = +contactId;

        const updatedEmailInfo = { ...emailInfo, to: contact.contact_info.EMAIL || '' };
        const updatedSmsInfo = { ...smsInfo, to: contact.contact_info.PHONE || '' };
        const updatedFbInfo = { ...fbInfo, to: contact.contact_info.FACEBOOK_MID || '' };
        const updatedTgInfo = { ...tgInfo, to: contact.contact_info.TELEGRAM_ID || '' };
        const updatedWebInfo = { to: contact.contact_info.CONTACT_ID || '' };

        let unseenMsgCounters = contact.unseen;
        unseenMsgCounters[selectedTab.toUpperCase()] = 0;

        const selectedContactUnseenAmount = contact.unseen.total;

        let isContactMuted = this.isContactMuted(contact.contact_info.contact_id, contact);

        if (!isContactMuted && selectedContactUnseenAmount > 0) {
          unseenAmountCounterLast -= selectedContactUnseenAmount;
        }

        const selectedContactIndex = contactsList.findIndex(contact => contact.contact_info.contact_id === contactId);

        // The contact list already has the correct last message info from chatlist
        const updatedContactsList = cloneDeep(contactsList);

        cont.setState(
          {
            contactsList: updatedContactsList,
            selectedContact: cloneDeep(selectedContact),
            unseenAmountCounterLast,
            chatTabsInit: true,
            selectedIndex: selectedContactIndex,
            emailInfo: updatedEmailInfo,
            smsInfo: updatedSmsInfo,
            fbInfo: updatedFbInfo,
            tgInfo: updatedTgInfo,
            webInfo: updatedWebInfo,
            chatMsgLoaded: true,
            contactIsLoaded: true,
            unseenMsgCounters: { ...unseenMsgCounters },
          },
          () => {
            cont.addChatScrollListener();
            if (!isMobile) cont.scrollToSelectedContact();

            if (contact.unseen.total && contact.unseen.total > 0) {
              cont.updateSeenTime();
              cont.scrollToFirstUnreadMsg();
            } else {
              cont.scrollToLastMsg();
            }
          }
        );
      },
    });
  };

  loadMoreMsgs = (cb) => {
    let { selectedContact } = this.state;

    const newSelectedContact = cloneDeep(selectedContact);
    const contactMsgs = newSelectedContact.msgs;
    const oldestMsgId = contactMsgs && contactMsgs.length && contactMsgs[0].id;

    let requestUrl = `/get_contacts_talks?contact_id=${selectedContact.id}&tab=${this.getChatSelectedTab()}`;
    if (oldestMsgId) requestUrl = `${requestUrl}&last_msg_id=${oldestMsgId}`;

    this.get({
      url: requestUrl,
      cb: (res) => {
        if (res._status === 'ok') {
          newSelectedContact.msgs = [ ...res.msgs, ...newSelectedContact.msgs ];
          this.setState({ selectedContact: newSelectedContact });
          if (cb) cb(res.msgs);
        }
      }
    });
  };

  updateSelectedContact = (unseenAmountCounter) => {
    let { selectedContact, isScrollInBottom } = this.state;

    if (!selectedContact) return;

    const newSelectedContact = cloneDeep(selectedContact);
    const contactMsgs = newSelectedContact.msgs;
    const newestMsgId = contactMsgs && contactMsgs.length && contactMsgs[contactMsgs.length - 1].id

    let requestUrl = `/get_new_contact_talks?contact_id=${selectedContact.id}&tab=${this.getChatSelectedTab()}`;
    if (newestMsgId) requestUrl = `${requestUrl}&last_msg_id=${newestMsgId}`;

    this.get({
      url: requestUrl,
      cb: (res) => {
        const contactSelectedId = +getUrlParameter('contact_id');
        if (res._status === 'ok' && contactSelectedId && contactSelectedId === selectedContact.id) {
          newSelectedContact.msgs = [ ...newSelectedContact.msgs, ...res.msgs ];

          this.setState({ selectedContact: newSelectedContact }, () => {
            if (isScrollInBottom && unseenAmountCounter && unseenAmountCounter > 0) {
              const chat = document.querySelector('.talks-chat-inner');
  
              if (chat) chat.scrollTop = chat.offsetHeight + chat.scrollHeight;
            }
          });
        }
      }
    });
  };

  startChangeTabText = () => {
    this.setState({ isTabTextChangeWorking: true });

    let intervalFlag = false;

    let pageTitleIntervalId = setInterval(() => {
      const pageTitleStr = intervalFlag ? `You have unread message(s)!` : '***';

      intervalFlag = !intervalFlag;

      document.querySelector('title').innerHTML = pageTitleStr;
      this.setState({ pageTitle: pageTitleStr });
    }, 1000);

    this.setState({ pageTitleIntervalId });
  };

  stopChangeTabText = () => {
    this.setState({ isTabTextChangeWorking: false });
    const { pageTitleIntervalId, pageTitleOnStart } = this.state;

    if (pageTitleIntervalId) {
      clearInterval(pageTitleIntervalId);
      document.querySelector('title').innerHTML = pageTitleOnStart;
      this.setState({ pageTitle: pageTitleOnStart });
    }
  };

  scrollToSelectedContact = () => {
    const { init } = this.state;
    const dialogSelected = document.querySelector('.talks-page-dialog-selected');

    const dialogList = document.querySelector('.talks-dialog-list');
    const searchAndSubsContainer = document.querySelector('.talks-search-subs-container');

    const dialogSelectedScrollTop =
      dialogSelected && dialogList && searchAndSubsContainer
        ? dialogSelected.offsetTop - dialogList.offsetHeight / 2 - searchAndSubsContainer.offsetHeight
        : 0;

    if (init && document.querySelector('.talks-dialog-list')) {
      document.querySelector('.talks-dialog-list').scrollTop = dialogSelectedScrollTop;
      this.setState({ init: false });
    }
  };

  scrollToLastMsg = () => {
    const chatContainer = document.querySelector('.talks-chat-inner');
    if (!chatContainer) return;

    // Use requestAnimationFrame to ensure DOM is updated
    requestAnimationFrame(() => {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    });
  };

  scrollToFirstUnreadMsg = () => {
    const { talksPageUnreadMsgLine } = this.props.classes;

    this.createUnreadLineElem();

    const chatContainer = document.querySelector('.talks-chat-inner');
    const unreadLine = document.querySelector(`.${talksPageUnreadMsgLine}`);

    if (unreadLine && chatContainer) {
      // Use requestAnimationFrame to ensure DOM is updated
      requestAnimationFrame(() => {
        chatContainer.scrollTop = unreadLine.offsetTop - chatContainer.offsetTop;
      });
    } else {
      this.scrollToLastMsg();
    }
  };

  debounce = (func, wait, immediate) => {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  addChatScrollListener = () => {
    const chat = document.querySelector('.talks-chat-inner');
    if (!chat) return;

    const cont = this;

    chat.onscroll = this.debounce(function (ev) {
      const isScrollInBottom = chat
        ? chat.scrollHeight - chat.scrollTop <= chat.offsetHeight + 50
        : false;

      cont.setState({
        isScrollInBottom,
      });
    }, 50);
  };

  createUnreadLineElem = () => {
    const { talksPageUnreadMsgLine } = this.props.classes;

    this.removeUnreadLineElem();

    const firstUnreadMsg = document.querySelector('.talks-message-unread');

    if (!firstUnreadMsg) return;

    const unreadDiv = document.createElement('div');
    unreadDiv.innerHTML = 'Unread messages';
    unreadDiv.className = talksPageUnreadMsgLine;

    firstUnreadMsg.parentNode.insertBefore(unreadDiv, firstUnreadMsg);
  };

  removeUnreadLineElem = () => {
    const { talksPageUnreadMsgLine } = this.props.classes;
    const unreadLineElem = document.querySelector(`.${talksPageUnreadMsgLine}`);

    if (unreadLineElem) unreadLineElem.remove();
  };

  removeUploadedImages = () => {
    const { imgUploadForm } = this.state;

    imgUploadForm.images = [];

    this.setState({ imgUploadForm: { ...imgUploadForm } });
  };

  isContactMuted = (contactId, contact, hiddenCategories) => {
    let isContactMuted = localStorage.getItem(`chat.notifications.${contactId}`) === 'muted';
    if (!isContactMuted && contact && contact.ancestors) {
      if (!hiddenCategories) hiddenCategories = this.getHiddenChatCategories();
      if (hiddenCategories && hiddenCategories.some(cid => contact.ancestors.includes(cid))) isContactMuted = true;
    }
    return isContactMuted;
  };

  onChatRecepientClick = (contactId) => {
    const { selectedContact } = this.state;

    const id = contactId && typeof contactId === 'number' ? contactId : selectedContact.id;

    window.open(`/node/${id}`, '_blank', 'noreferrer noopener').focus();
  };

  onChatRecepientInHeaderClick = (contactId) => {
    const { selectedContact } = this.state;

    const id = contactId && typeof contactId === 'number' ? contactId : selectedContact.id;

    this.setState({
      chatRecepientEditModalOpened: id,
    });
  };

  onChatRecipientMute = (contactId) => {
    let { selectedIndex, contactsList, unseenAmountCounterLast } = this.state;

    localStorage.setItem(`chat.notifications.${contactId}`, 'muted');
    contactsList[selectedIndex].isMuted = true;

    let unseenAmountCounter = unseenAmountCounterLast;

    if (contactsList[selectedIndex].unseen.total) unseenAmountCounter -= contactsList[selectedIndex].unseen.total;
    this.setState({ contactsList, unseenAmountCounterLast: unseenAmountCounter });
  };

  onChatRecipientUnmute = (contactId) => {
    let { selectedIndex, contactsList, unseenAmountCounterLast } = this.state;

    localStorage.removeItem(`chat.notifications.${contactId}`);
    contactsList[selectedIndex].isMuted = false;

    let unseenAmountCounter = unseenAmountCounterLast;

    if (contactsList[selectedIndex].unseen.total) unseenAmountCounter += contactsList[selectedIndex].unseen.total;
    this.setState({ contactsList, unseenAmountCounterLast: unseenAmountCounter });
  };

  onChatTabClick = (tabValue) => {
    // Update URL with new tab value
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('tab', tabValue);
    window.history.replaceState({}, '', currentUrl.toString());

    const { selectedContact, chatTabs, selectedIndex, contactsList, emailInfo, smsInfo, fbInfo, tgInfo, webInfo } = this.state;
    const updatedChatTabs = chatTabs.map(tab => ({
      ...tab,
      isSelected: tab.value === tabValue
    }));

    this.setState(
      {
        chatMsgLoaded: false,
        selectedContact: { ...selectedContact },
        chatTabs: updatedChatTabs,
      },
      () => {
        this.removeUnreadLineElem();
        this.removeUploadedImages();

        const contact = contactsList[selectedIndex];
        const contactId = selectedContact.id;

        this.get({
          url: `/get_contacts_talks?contact_id=${contactId}&tab=${tabValue}`,
          cb: (selectedContact) => {
            const unseenMsgCounters = contact.unseen;
            selectedContact.id = contactId;

            this.setState(
              {
                selectedContact: { ...selectedContact },
                unseenMsgCounters: { ...unseenMsgCounters },
                contactsList,
                chatMsgLoaded: true,
              },
              () => {
                if (contact.unseen[tabValue.toUpperCase()] && contact.unseen[tabValue.toUpperCase()] > 0) {
                  this.updateSeenTime();
                  this.scrollToFirstUnreadMsg();
                } else {
                  this.scrollToLastMsg();
                }
              }
            );
          },
        });
      }
    );
  };

  getChatSelectedTab = () => {
    const { chatTabs } = this.state;

    if (!chatTabs || !chatTabs.length) return '';
    
    const tab = chatTabs.find((tab) => tab.isSelected);
    return tab ? tab.value.toLowerCase() : chatTabs[0].value.toLowerCase();
  };

  validateChatInfoEmails = (key, value) => {
    let { isChatInfoValid } = this.state;

    if (tobeor(key, ['to', 'from', 'replyTo'])) {
      const isValidEmail = validateEmail(value);

      isChatInfoValid[key] = !isValidEmail;
    }

    this.setState({ isChatInfoValid });
  };

  onChatEmailInputChange = (key, e) => {
    let { emailInfo } = this.state;
    emailInfo[key] = e.target.value;

    if (key !== 'subject') {
      this.validateChatInfoEmails(key, e.target.value);
    }

    this.setState({ emailInfo: { ...emailInfo } });
  };

  onChatFbInfoChange = (key, e) => {
    let { fbInfo } = this.state;

    fbInfo[key] = e.target.value;

    this.setState({ fbInfo: { ...fbInfo } });
  };

  onChatTgInfoChange = (key, e) => {
    let { tgInfo } = this.state;

    tgInfo[key] = e.target.value;

    this.setState({ tgInfo: { ...tgInfo } });
  };

  onChatTelephoneInputChange = (key, e) => {
    let { smsInfo } = this.state;
    smsInfo[key] = e.target.value;

    this.setState({ smsInfo: { ...smsInfo } });
  };

  onChatSelectChange = (e) => {
    const { contactsList, selectedIndex, selectedContact, msgTemplates } = this.state;
    const { setup_contacts_tbox } = this.props;

    let tmplts = msgTemplates;

    let chatTemplateIndex = tmplts.findIndex((tmplt) => {
      return tmplt.id === +e.target.value;
    });

    const chatTemplatePids = [];

    if (chatTemplateIndex !== -1) {

      if (contactsList[selectedIndex].ancestors && setup_contacts_tbox) {
        if (tmplts[chatTemplateIndex].stimuls && tmplts[chatTemplateIndex].stimuls[0].pids.length) {
          const pids = [ ...tmplts[chatTemplateIndex].stimuls[0].pids ];

          pids.forEach(pid => {
            for (const ancestor of contactsList[selectedIndex].ancestors) {
              const subNode = setup_contacts_tbox.nodes[ancestor];

              if (subNode && subNode.box.r) {
                for (const conceptRsts of Object.values(subNode.box.r)) {
                  for (const rst of conceptRsts) {
                    if (pid === rst.id) {
                      chatTemplatePids.push({
                        id: rst.id,
                        title: rst.title,
                      });
                      return;
                    }
                  };
                };
              }
            }
          })
        };
      };

      this.onInputChange(selectedContact.id, tmplts[chatTemplateIndex].stimuls[0].text);

      this.setState({
        chatTemplate: e.target.value,
        chatTemplateId: tmplts[chatTemplateIndex].id,
        chatTemplatePids,
      });
    } else {
      this.onInputChange(selectedContact.id, null);

      this.setState({
        chatTemplate: 'none',
        chatTemplatePids,
      });
    }
  };

  onDeleteMsgClick = () => {
    const { selectedContact } = this.state;
    const { id, index } = this.state.deleteMsgModal;

    const msgs = cloneDeep(selectedContact.msgs);

    msgs[index].body = 'deleted';
    msgs[index].formatted_body = 'deleted';
    msgs[index].type = 'deleted';

    selectedContact.msgs = msgs;

    const newSelectedContact = { ...selectedContact };

    this.setState({ loadingConfirmDeleteMsg: true }, () => {
      this.get({
        url: `/del_msg?id=${id}`,
        cb: () => {
          this.setState({
            selectedContact: newSelectedContact,
            loadingConfirmDeleteMsg: false,
            deleteMsgModal: {
              isOpened: false,
              id: 0,
              index: 0,
            },
          });
        },
      });
    });
  };

  onUnseenMsgClick = (id, notSeen, index) => {
    const tab = this.getChatSelectedTab();
    const data = objectToQuerystring({ id, tab });
    const { contactsList, selectedContact, selectedIndex, unseenAmountCounterLast } = this.state;

    let isContactMuted = this.isContactMuted(selectedContact.id, contactsList[selectedIndex]);

    let unseenAmountCounter = unseenAmountCounterLast;

    if (!notSeen) {
      contactsList[selectedIndex].unseen.total += 1;
      if (!isContactMuted) unseenAmountCounter += 1;
    } else {
      contactsList[selectedIndex].unseen.total -= 1;
      if (!isContactMuted) unseenAmountCounter -= 1;
    }

    const msgs = cloneDeep(selectedContact.msgs);

    msgs[index].notSeen = !notSeen;

    selectedContact.msgs = msgs;

    const newContactsList = [ ...contactsList ];
    const newSelectedContact = { ...selectedContact };

    this.postWithData({
      url: `/set_msg_unseen`,
      data,
      cb: () => {
        this.setState({
          unseenAmountCounterLast: unseenAmountCounter,
          selectedContact: newSelectedContact,
          contactsList: newContactsList,
        });
      },
    });
  };

  getHiddenChatCategories = () => {
    const hiddenCids = localStorage.getItem(HIDDEN_CHAT_CATEGORIES);
    let hiddenCidsArray;
    if (hiddenCids) {
      try {
        hiddenCidsArray = JSON.parse(hiddenCids);
      } catch (e) {
        console.log('Error during parsing hidden chat categories: ' + e);
      }
    }
    return hiddenCidsArray;
  };

  initContactSelectCheckboxes = (setup_contacts_tbox) => {
    const { initContactSelectCheckboxes } = this.state;

    if (!initContactSelectCheckboxes && setup_contacts_tbox && setup_contacts_tbox.nodes) {
      let subValue;
      const cids = Object.keys(setup_contacts_tbox.nodes).map(Number);

      let hiddenCidsArray = this.getHiddenChatCategories();
      if (hiddenCidsArray) {
        for (let i = 0; i < hiddenCidsArray.length; i++) {
          const index = cids.indexOf(hiddenCidsArray[i]);
          if (index !== -1) cids.splice(index, 1);
        }
        subValue = [...cids];
      } else {
        subValue = [CHECKBOX_ALL, ALL_CATEGORIES, ...cids];
      }

      this.setState({ subValue, initContactSelectCheckboxes: true });
    }
  };

  onSubSelectChange = (e) => {
    const { subValue } = this.state;
    const { setup_contacts_tbox } = this.props;
    let subValueNew = [...e.target.value];

    const indexPlaceholder = subValueNew.indexOf(SELECT_PLACEHOLDER);
    if (indexPlaceholder > -1) subValueNew.splice(indexPlaceholder, 1);

    if (setup_contacts_tbox && setup_contacts_tbox.nodes && subValueNew.includes(CHECKBOX_ALL) && !subValue.includes(CHECKBOX_ALL)) {
      const cids = Object.keys(setup_contacts_tbox.nodes).map(Number);
      subValueNew = [CHECKBOX_ALL, ALL_CATEGORIES, ...cids];
    } else if (subValue.includes(CHECKBOX_ALL) && !subValueNew.includes(CHECKBOX_ALL)) {
      subValueNew = [];
    } else if (subValue.includes(CHECKBOX_ALL) && subValueNew.includes(CHECKBOX_ALL)) {
      let index = subValueNew.indexOf(CHECKBOX_ALL);
      if (index !== -1) subValueNew.splice(index, 1);
    }

    if (setup_contacts_tbox && setup_contacts_tbox.nodes) {
      const hiddenCids = [];
      Object.keys(setup_contacts_tbox.nodes).forEach(cid => {
        if (!subValueNew.includes(+cid)) hiddenCids.push(+cid);
      });

      if (!hiddenCids.length) localStorage.removeItem(HIDDEN_CHAT_CATEGORIES);
      else localStorage.setItem(HIDDEN_CHAT_CATEGORIES, JSON.stringify(hiddenCids));
    }

    this.setState({ subValue: subValueNew });
  };

  onChatSettingsOpen = (event) => {
    this.setState({
      chatSettingsAnchor: event.currentTarget,
      isSendPopoverVisible: true,
    });
  };

  onChatSettingsClose = () => {
    this.setState({ chatSettingsAnchor: null, isSendPopoverVisible: false });
  };

  onChatRadioSelect = (value) => {

    this.post({
      url: `/setsettings?chat_hotkeys=${value}`,
      cb: (data) => {
        if (data._status === 'ok') {
          this.props.updateSetupData();
        }
      }
    });
  };

  onChatHotkeyPress = (key, pressed) => {
    const { hotkeysPressed } = this.state;

    hotkeysPressed[key] = pressed;

    this.setState({ hotkeysPressed: { ...hotkeysPressed } });
  };

  onSendEmailClick = (e, contactInfo, cb) => { // check for users who use emails
    e.preventDefault();

    const {
      selectedContactId,
      chatTemplatePids,
      selectedTab,
      emailInfo,
      smsInfo,
      fbInfo,
      tgInfo,
    } = contactInfo;

    let {
      chatTemplateId,
      imgUploadForm,
    } = this.state;

    let pids = [];

    if (chatTemplatePids.length) {
      chatTemplatePids.forEach((pid) => pids.push(pid.id));
    }

    const msg = this.getDraftMsg(selectedContactId);

    const data = {
      rest: 1,
      flow: chatTemplateId,
      from: emailInfo.from,
      to: emailInfo.to,
      subject: emailInfo.subject,
      replyto: emailInfo.replyTo,
      body: msg,
      pids: JSON.stringify(pids),
    };

    let dataStringified = objectToQuerystring(data);

    if (imgUploadForm.images.length) {
      imgUploadForm.images.forEach((img) => {
        dataStringified += `&img=${img.url}`;
      });
    }

    this.postWithData({
      url: '/sendemail',
      data: dataStringified,
      cb: () => {
        this.onInputChange(selectedContactId, null);

        this.setState({
          chatTemplate: 'none',
          chatTemplateId: '',
          chatTemplatePids: [],
        });
        if (cb) cb();
      },
      errorCb: () => {
        this.onInputChange(selectedContactId, null);

        this.setState({
          chatTemplate: 'none',
          chatTemplateId: '',
          chatTemplatePids: [],
        });
        if (cb) cb();
      },
    });
  };

  onSendMsgClick = (e, contactInfo, cb) => {
    e.preventDefault();

    const {
      selectedContactId,
      chatTemplatePids,
      selectedTab,
      emailInfo,
      smsInfo,
      fbInfo,
      tgInfo,
      webInfo,
    } = contactInfo;

    let {
      chatTemplateId,
      imgUploadForm,
    } = this.state;

    let pids = [];

    if (chatTemplatePids.length) chatTemplatePids.forEach((pid) => pids.push(pid.id));

    const tab = selectedTab.value;
    const sendInfo = tab === 'sms' ? smsInfo 
                  : tab === 'telegram' ? tgInfo 
                  : tab === 'facebook' ? fbInfo
                  : tab === 'web' ? webInfo 
                  : null;

    const sendUrl = tab === 'sms' ? '/sendsms' 
                 : tab === 'telegram' ? '/sendtelegram' 
                 : tab === 'facebook' ? '/sendfacebook'
                 : tab === 'web' ? '/sendweb'
                 : '';

    const msg = this.getDraftMsg(selectedContactId);

    const data = {
      contact_id: selectedContactId,
      rest: 1,
      from: sendInfo.from,
      flow: chatTemplateId,
      to: sendInfo.to,
      body: msg,
      pids: JSON.stringify(pids),
    };

    let dataStringified = objectToQuerystring(data);

    if (imgUploadForm.images.length) {
      imgUploadForm.images.forEach((img) => {
        dataStringified += `&img=${img.url}`;
      });
    }

    this.postWithData({
      url: sendUrl,
      data: dataStringified,
      cb: () => {
        const { contactsList } = this.state;

        const selectedContactInfo = contactsList.find(contact => contact.contact_info.contact_id === selectedContactId);

        selectedContactInfo.body = msg;
        selectedContactInfo.timestamp = new Date().getTime();
        selectedContactInfo.type = tab.toUpperCase();

        let filteredContactsList = contactsList.filter(contact => contact.contact_info.contact_id !== selectedContactId);
        filteredContactsList.unshift(selectedContactInfo);

        const { getContactsHolded } = this.state;
        if (getContactsHolded) {
          if (this.props.addon) this.getContactsByAncestor(true);
          else this.getContacts(true);
        }

        this.onInputChange(selectedContactId, null);

        this.setState(
          {
            contactsList: filteredContactsList,
            selectedIndex: 0,
            chatTemplate: 'none',
            chatTemplateId: '',
            chatTemplatePids: [],
          },
          () => {
            if (+getUrlParameter('contact_id') === selectedContactId) this.onContactSelect(selectedContactId, 0, false, true);
          }
        );
        if (cb) cb();
      },
      errorCb: () => {
        this.onInputChange(selectedContactId, null);

        this.setState({
          chatTemplate: 'none',
          chatTemplateId: '',
          chatTemplatePids: [],
        });
        if (cb) cb();
      },
    });
  };

  onSendMsgChangeStatus = (isSending) => {
    if (this.state.isSendingMsg !== isSending) this.setState({ isSendingMsg: isSending });
  };

  onInputChange = (contactId, value) => {
    const { draftMessages } = this.state;

    if (!contactId) return;

    const draftMessagesNew = produce(draftMessages, draftMessages => {
      draftMessages[contactId] = value || null;
    });

    this.setState({ draftMessages: draftMessagesNew });
  };

  getDraftMsg = (contactId) => {
    const { draftMessages } = this.state;

    if (!draftMessages || !contactId || !draftMessages[contactId]) return '';

    return draftMessages[contactId];
  };

  stateValueSwitcher = (key) => {
    const value = this.state[key];

    this.setState({ [key]: !value });
  };

  onRemovePidClick = (id) => {
    const { chatTemplatePids } = this.state;

    const chatTemplatePidsFiltered = chatTemplatePids.filter((pid) => pid.id !== id);

    this.setState({ chatTemplatePids: chatTemplatePidsFiltered });
  };

  getRecipient = (contactInfo) => {
    let recipient =
        contactInfo.title ||
        `${contactInfo.FIRST_NAME} ${contactInfo.LAST_NAME}` ||
        contactInfo.EMAIL ||
        contactInfo.PHONE;
    return recipient;
  };

  onImageUploadCb = (uploadedImgs) => {
    const { imgUploadForm } = this.state;

    const uploadedImgsArr = [...imgUploadForm.images, ...uploadedImgs];
    imgUploadForm.images = uploadedImgsArr;

    this.setState({ imgUploadForm: { ...imgUploadForm } });
  };

  removeUploadedTempImage = (index) => {
    const { imgUploadForm } = this.state;

    this.postWithData({
      url: `/del_temp_img`,
      data: objectToQuerystring({ picName: imgUploadForm.images[index].name }),
      cb: () => {
        imgUploadForm.images.splice(index, 1);

        this.setState({ imgUploadForm: { ...imgUploadForm } });
      },
    });
  };

  toggleUploadImgModal = (isOpened) => {
    const { imgUploadForm } = this.state;

    imgUploadForm.isOpened = isOpened;

    this.setState({ imgUploadForm: { ...imgUploadForm } });
  };

  toggleDeleteMsgModal = (isOpened, id = 0, index = 0) => {
    const { deleteMsgModal } = this.state;

    deleteMsgModal.isOpened = isOpened;
    deleteMsgModal.index = index;
    deleteMsgModal.id = id;

    this.setState({ deleteMsgModal });
  };

  render() {
    const { account, classes, setup_accounts, setup_contacts_tbox } = this.props;

    const {
      fbInfo,
      tgInfo,
      smsInfo,
      chatTabs,
      subValue,
      subsData,
      isLastTab,
      emailInfo,
      msgTemplates,
      chatTemplate,
      contactsList,
      chatMsgLoaded,
      selectedIndex,
      imgUploadForm,
      hotkeysPressed,
      chatTemplateId,
      deleteMsgModal,
      selectedContact,
      contactIsLoaded,
      isChatInfoValid,
      channelConceptTo,
      contactsIsLoaded,
      chatTemplatePids,
      unseenMsgCounters,
      chatSettingsAnchor,
      isSendPopoverVisible,
      loadingConfirmDeleteMsg,
      selectedContactMobileValue,
      chatRecepientEditModalOpened,
    } = this.state;

    const selectedContactInfo = selectedContact && contactsList.find(contact => contact.contact_info.contact_id === selectedContact.id);

    const contactName = selectedContact && selectedContact.id && selectedContactInfo && selectedContactInfo.contactTitle;

    const selectClassNames = {
      select: classes.trplSelect,
      icon: classes.trplSelectIcon,
      root: classes.trplSelectContainer,
    };

    const menuProps = {
      classes: {
        paper: classes.trplSelectMenu,
      },
    };

    return (
      <div>
        <ActionConfirmation
          modalData={{
            open: deleteMsgModal.isOpened,
            contentText: "Delete this Message?",
            contentBoldText: "",
          }}
          loadingConfirm={loadingConfirmDeleteMsg}
          acceptHandler={this.onDeleteMsgClick}
          onClose={() => this.toggleDeleteMsgModal(false)}
        />

        <TrplFormFullScreenDialog
          isOpen={!!chatRecepientEditModalOpened}
          paperFullScreenStyles={classes.trplFormPaper}
        >
          <div className={classes.pb120}>
            <TrplForm
              mode="edit"
              groups={[]}
              closeModal={() => this.setState({ chatRecepientEditModalOpened: null })}
              iId={chatRecepientEditModalOpened}
            />
          </div>
        </TrplFormFullScreenDialog>

        {!isLastTab ? (
          <div className={`talks-page ${classes.talksPageContainer}`}>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <ChatBubbleOutlineOutlinedIcon style={{ fontSize: 85, marginBottom: '20px' }} />

              <h2>Sorry, we support only one active chat tab</h2>
            </div>
          </div>
        ) : (
          <div className={`talks-page ${classes.talksPageContainer}`}>
            <Media query="(min-width: 900px)">
              <Contacts
                account={account}
                subsData={subsData}
                subValue={subValue}
                subs={setup_contacts_tbox}
                contactsList={contactsList}
                selectedIndex={selectedIndex}
                getDraftMsg={this.getDraftMsg}
                selectedContact={selectedContact}
                channelConceptTo={channelConceptTo}
                contactsIsLoaded={contactsIsLoaded}
                onContactSelect={this.onContactSelect}
                selectedContactInfo={selectedContactInfo}
                onSubSelectChange={this.onSubSelectChange}
                getChatSelectedTab={this.getChatSelectedTab}
              />
            </Media>

            <Media query="(max-width: 900px)">
              {!selectedContactMobileValue ? (
                <span className={classes.talksPageContactSelectText}>Please, select contact</span>
              ) : null}
            </Media>

            <Media query="(max-width: 900px)">
              <Select
                MenuProps={menuProps}
                disableunderline
                classes={selectClassNames}
                renderValue={(value) => value}
                value={selectedContactMobileValue}
                className={classes.talksPageContactSelect}
                onChange={(e) => {
                  const index = e.target.value;

                  const recipient = this.getRecipient(contactsList[index].contact_info);

                  const contact = contactsList[index];

                  this.onContactSelect(contact.contact_info.contact_id, index);
                  
                  this.setState({ selectedContactMobileValue: recipient });
                }}
              >
                {contactsList.map((contact, index) => {
                  let recipient = this.getRecipient(contact.contact_info);
                  const location = window.location.href;

                  const linkParam = `contact_id=${contact.contact_info.contact_id}`;
                  let linkUrl = `chat?${linkParam}`;
                  
                  if (location.split('/').includes('addon')) {
                    linkUrl = `/addon/chat?${linkParam}`;
                  }

                  let isSelected = index === selectedIndex;

                  if (contact.unseen.total > 0) {
                    recipient = `${recipient} (${contact.unseen.total})`;
                  }

                  return (
                    <Link
                      key={index}
                      value={index}
                      className={`${classes.talksPageContactSelectLink} ${
                        isSelected ? classes.talksPageContactSelectLinkSelected : ''
                      }`}
                      to={linkUrl}
                    >
                      {recipient}
                    </Link>
                  );
                })}
              </Select>
            </Media>

            <div className={classes.talksPageChat}>
              {!contactIsLoaded && selectedContact ? <Loader /> : null}

              {contactIsLoaded && selectedContact ? (
                <Chat
                  loadMoreMsgs={this.loadMoreMsgs}
                  onChatRecipientMute={this.onChatRecipientMute}
                  onChatRecipientUnmute={this.onChatRecipientUnmute}
                  scrollToLastMsg={this.scrollToLastMsg}
                  account={account}
                  setupAccounts={setup_accounts}
                  chatSettingsAnchor={chatSettingsAnchor}
                  hotkeysPressed={hotkeysPressed}
                  emailInfo={emailInfo}
                  smsInfo={smsInfo}
                  fbInfo={fbInfo}
                  tgInfo={tgInfo}
                  msgTemplates={msgTemplates}
                  subsData={subsData}
                  contactName={contactName}
                  chatTemplatePids={chatTemplatePids}
                  chatTemplate={chatTemplate}
                  chatTemplateId={chatTemplateId}
                  chatTabs={chatTabs}
                  getDraftMsg={this.getDraftMsg}
                  chatMsgLoaded={chatMsgLoaded}
                  hash={''}
                  selectedContact={selectedContact}
                  unseenMsgCounters={unseenMsgCounters}
                  isChatInfoValid={isChatInfoValid}
                  imgUploadForm={imgUploadForm}
                  isSendPopoverVisible={isSendPopoverVisible}
                  onSendMsgChangeStatus={this.onSendMsgChangeStatus}
                  onChatRecepientInHeaderClick={this.onChatRecepientInHeaderClick}
                  onChatRecepientClick={this.onChatRecepientClick}
                  stateValueSwitcher={this.stateValueSwitcher}
                  toggleDeleteMsgModal={this.toggleDeleteMsgModal}
                  onUnseenMsgClick={this.onUnseenMsgClick}
                  onChatHotkeyPress={this.onChatHotkeyPress}
                  onChatRadioSelect={this.onChatRadioSelect}
                  onChatSettingsOpen={this.onChatSettingsOpen}
                  onChatSettingsClose={this.onChatSettingsClose}
                  onChatTabClick={this.onChatTabClick}
                  onChatSelectChange={this.onChatSelectChange}
                  onSendEmailClick={this.onSendEmailClick}
                  onSendMsgClick={this.onSendMsgClick}
                  onInputChange={this.onInputChange}
                  onChatEmailInputChange={this.onChatEmailInputChange}
                  onChatTelephoneInputChange={this.onChatTelephoneInputChange}
                  onChatFbInfoChange={this.onChatFbInfoChange}
                  onChatTgInfoChange={this.onChatTgInfoChange}
                  onRemovePidClick={this.onRemovePidClick}
                  onImageUploadCb={this.onImageUploadCb}
                  removeUploadedTempImage={this.removeUploadedTempImage}
                  toggleUploadImgModal={this.toggleUploadImgModal}
                />
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
  setup: state.meta.setup,
  account: state.meta.account,
  setup_accounts: state.meta.setup_accounts,
  setup_contacts_tbox: state.meta.setup_contacts_tbox,
}), { setSetupAccounts, updateSetupData, setSetupContactsTboxData })(withStyles(styles)(ChatContainer));